import { ReactSVG } from "react-svg";

const WidgetIconThree = ({ iconProp, colorProp, cursorProp = "pointer", widthIconProp = "100%", heightIconProp = "100%" }) => {
  return (
    <div style={{ cursor: cursorProp, flexShrink: 0 }}>
      <ReactSVG
        src={iconProp}
        beforeInjection={(svg) => {
          svg.querySelectorAll("*").forEach((el) => {
            el.setAttribute("fill", colorProp);
          });
          svg.setAttribute("width", widthIconProp);
          svg.setAttribute("height", heightIconProp);
          svg.setAttribute("style", "overflow: visible;");
        }}
      />
    </div>
  );
};

export default WidgetIconThree;
